<template>
<div>
    <div>
      <div class="main-body">
        <main-view 
          v-if="!loading"
        />
      </div>
    </div>
    <settings />
    </div>
</template>

<script>
  import utils from '@/services/utils.js'
  import api from '@/services/api'
  import constants from '@/constants'
  import MainView from '@/views/View.vue'
  import Settings from './settings/Index.vue'
  export default {
    components: {
      MainView,
      Settings,
    },
    data () {
      return {
        loading: true,
      }
    },
    computed: {
      isCommonMenus () {
        return this.$route.path.indexOf('/common-menus') >= 0
      },
    },
    mounted (){
      this.getUserInfo()
    },
    methods: {
      getUserInfo () {
        const userID = utils.getUserID()
        if (!userID || userID.length <= 0) {
          this.$router.push('/login')
        } else {
          api.getItem('users', true, userID).then(response => {
            this.$store.state.app.userID = response.ID
            this.$store.state.app.userName = response.Name
            this.loading = false
          })
        }
      }
    }
  }
</script>
<style lang="scss">
  h1 {
    font-weight: normal;
  }
  .sidebar {
    float: left;
  }
  .main-body {
    // margin-left:80px;
  }
  // @import '@/styles/index.scss';

  // /* Remove in 1.2 */
  // .v-datatable thead th.column.sortable i {
  //   vertical-align: unset;
  // }
  // body {
  //   background-color:#eee;
  // }
</style>
